import React from 'react';
import { connect } from 'react-redux';

import { selectIsVisible } from './selectors';
import { updateQueryString } from '../../redux/router/actions';

import Modal from './Modal';

const ModalConnected = (props) => <Modal {...props} />;

const mapStateToProps = (state, props) => ({
  isVisible: selectIsVisible(state, props),
});

const mapActionsToProps = {
  updateQueryString,
};

export default connect(mapStateToProps, mapActionsToProps)(ModalConnected);
